// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCoWig-_vWPS2uOYGZW_eHJRzRVMs9J7Jc",
  authDomain: "fanabeazana-antily-app.firebaseapp.com",
  projectId: "fanabeazana-antily-app",
  storageBucket: "fanabeazana-antily-app.appspot.com",
  messagingSenderId: "1052187292198",
  appId: "1:1052187292198:web:b7a20e70fe77f87100ace7",
  measurementId: "G-N0QKY3159Q",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
